import PropTypes from "prop-types";
import { Link } from "react-router-dom";
const BreadcrumbClientProtection = () => {
  return (
    <div
      className="ht__bradcaump__area_market"
      style={{
        background: `rgba(0, 0, 0, 0) url(${
          process.env.PUBLIC_URL + "/images/about/bull_right_side.jpg"
        }) repeat scroll center center/105% 100%`,
      }}
    >
      <div className="ht__bradcaump__container_market">
        <div className="container">
          <div className="row">
            <div className="col-lg-9">
              <h1>Trade smarter. Stay safer. Protect what matters.</h1>
              <p>
                In a fast-moving digital world, your security is our priority.
                Learn how to identify scams, prevent fraud, and protect your
                personal and financial data while trading with confidence on The
                Pips.
              </p>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/register"}
              >
                Register
              </Link>
              <span style={{ marginRight: "15px" }}></span>
              <Link
                className="slide__btn dg__btn"
                to={process.env.PUBLIC_URL + "/company/contact"}
              >
                Try free demo
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

BreadcrumbClientProtection.propTypes = {
  title: PropTypes.string,
};

export default BreadcrumbClientProtection;
